export default __webpack_public_path__ + "static/media/burger.fe75d4d2.png";